import { render, staticRenderFns } from "./NotAutorized.vue?vue&type=template&id=6c96bee0&"
import script from "./NotAutorized.vue?vue&type=script&lang=js&"
export * from "./NotAutorized.vue?vue&type=script&lang=js&"
import style0 from "./NotAutorized.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports